module.exports = __webpack_public_path__ + "img/kpis.47fb8bfa.svg";